export default __webpack_public_path__ + "e6b1dafde8348e23047aef2b3997b37d.png";